import { useEffect, useState, useRef } from 'react';
import { GoUnmute, GoMute } from "react-icons/go";
import AOS from 'aos';
import 'aos/dist/aos.css';
import DesktopRibbon1 from '../assets/common/desktop-ribbon-1.jpg';
import DesktopRibbon2 from '../assets/common/desktop-ribbon-2.jpg';
import DesktopRibbon3 from '../assets/common/desktop-ribbon-3.jpg';
import MobileRibbon1 from '../assets/common/mobile-ribbon-1.jpg';
import MobileRibbon2 from '../assets/common/mobile-ribbon-2.jpg';
import MobileRibbon3 from '../assets/common/mobile-ribbon-3.jpg';
import MobileRibbon4 from '../assets/common/mobile-ribbon-4.jpg';
import I1 from '../assets/home/home-section-1.png';
import UCLOGO from '../assets/home/uc-logo.png';
import ImageCarousel from '../components/Common/ImageCarousel';
import uc1 from '../assets/home/uc-01.jpg';
import uc2 from '../assets/home/uc-02.jpg';
import uc3 from '../assets/home/uc-03.jpg';
import uc4 from '../assets/home/uc-04.jpg';
import KingsImage from '../assets/news/news-7.jpg';
import NewsPanel from '../components/Common/news-panel';
import newsData from '../data/news-data'


const CarouselImages = [uc1, uc2, uc3, uc4];
const Text1 = `New Era Education is a pioneering force in educational management since our establishment in 2018. At New Era Education, we are dedicated to transforming the landscape of education in Egypt by introducing innovative and unparalleled educational experiences. Our mission is to provide Egyptian students with access to the highest quality educational institutions, setting new standards of excellence in the community.`
const Text2 = `Uppingham Cairo is the distinguished international school committed to providing a world-class education rooted in excellence, innovation, and holistic development. As part of Uppingham School, the leading independent school in the UK, founded in 1584, we bring a rich heritage of educational excellence spanning over four centuries. Our mission is to nurture young minds, empower future leaders, and shape global citizens, offering a dynamic and engaging learning environment that fosters intellectual curiosity, critical thinking, creativity, and personal growth. Our academic programs are designed to challenge and inspire pupils to achieve their highest potential. Uppingham Cairo offers a comprehensive curriculum that includes the International Baccalaureate (IB), IGCSE, and A Levels, preparing our pupils for success in universities worldwide. Currently, we are accepting admissions from FSI - Y9.`
const DesktopRibbon = [DesktopRibbon1, DesktopRibbon2, DesktopRibbon3];
const MobileRibbon = [MobileRibbon1, MobileRibbon2, MobileRibbon3, MobileRibbon4];


const Home = () => {
  useEffect(() => {AOS.init({duration: 1000, easing: 'ease-in-out', once: true,});}, []);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const lastNews = newsData[newsData.length - 1];
  const [muted, setMuted] = useState(true);
  const videoRef = useRef(null);

  return (
    <div className="w-full overflow-hidden relative">
      {/*DESKTOP HERO SECTION */}
      <div className="hidden md:block slider-container mb-10" data-aos="fade-up">
      <div className="slider">
      {Array.from({ length: 200 }).map((_, index) => (
      <img src={DesktopRibbon[index % DesktopRibbon.length]} alt={`Hero ${index + 1}`} key={index} className="hero-image" />))}</div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full text-center font-tenor text-white">
      <p className="text-2xl uppercase font-bold mb-4">the future of education is here</p>
      <p className="text-lg px-[10%]">Transforming education through global<br/>partnerships, academic excellence, and community-driven innovation</p>
      </div></div>

      {/*MOBILE HERO SECTION */}
      <div className="block md:hidden slider-container" data-aos="fade-up">
      <div className="slider-mobile">{Array.from({ length: 200 }).map((_, index) => (<img src={MobileRibbon[index % MobileRibbon.length]} alt={`Hero ${index + 1}`} key={index} className="hero-image" />))}</div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full text-center font-tenor text-white">
      <p className="text-2xl uppercase font-bold mb-4 px-8 ">the future of education is here</p>
      <p className="text-sm px-8">Transforming education through global partnerships, academic excellence, and community-driven innovation</p></div></div>

<div data-aos="fade-up" className="p-8 md:my-10 md:mx-32 md:px-20 md:py-6 md:rounded-[2.3rem] text-blue font-tenor">
  <div className="grid md:grid-cols-2 items-center gap-6">
  <div> <p className="text-2xl uppercase mb-4 font-bold text-center md:text-left">Expanding Horizons</p>
  <div className=" md:hidden overflow-hidden rounded-xl mb-4">
  <img src={KingsImage} alt="" className="h-full w-full object-cover transition-transform duration-500 ease-in-out transform hover:scale-105 rounded-xl"/></div>
  <p className="text-base md:text-lg font-bold text-center md:text-left">{lastNews.title}</p>
  <div className="mt-4 md:mt-16 flex justify-center md:justify-start"><button className="md:mx-0 mx-auto text-blue bg-yellow text-base py-2 px-12 rounded-md font-semibold transition duration-200 uppercase hover:scale-105" onClick={() => setIsPanelOpen(true)}>Read More</button></div></div>
<div className="hidden md:flex overflow-hidden rounded-xl ml-4">
  <img src={KingsImage} alt="" className="h-full w-full object-cover transition-transform duration-500 ease-in-out transform hover:scale-105 rounded-xl"/></div></div></div>

      {/* FIRST SECTION */}
      <div className="grid grid-cols-1 md:gap-4 relative"><div data-aos="fade-up">
      <div data-aos="fade-up" className="p-8 md:mx-10 md:px-10 md:py-6 md:rounded-[2.3rem] bg-blue text-white font-tenor">
      <p className="uppercase text-left text-2xl md:mt-2 font-bold">about</p>
      <p className="uppercase text-left text-2xl text-green mb-3 font-bold">who we are</p>
      <p data-aos="fade-left" className="md:text-justify text-sm md:text-base mb-3 md:pr-[55%]">{Text1}</p>
      <button className="text-blue md:text-sm text-xs font-semibold bg-yellow px-3 py-2 md:mb-2 rounded-xl uppercase hover:scale-105"onClick={() => (window.location.href = "/about")}>learn about our vision</button>
      
      {/* SECOND SECTION MOBILE*/}
      <div className="lg:hidden mt-8 text-white font-tenor bg-blue">
      <p data-aos="fade-left" className="uppercase mb-2 text-2xl font-bold">school management</p>
      <p data-aos="fade-left" className="text-sm mb-3">Specialized in the establishment and operating of educational institutions.</p>
      <button className="text-blue text-xs font-semibold bg-yellow px-3 py-2 rounded-xl uppercase hover:scale-105 " onClick={() => (window.location.href = "/projects")}>Explore Our Schools and Programs</button></div>
      </div>
      </div>
     
    
      {/* SECOND SECTION DESKTOP*/}
      <div data-aos="fade-left"><div className="hidden md:block px-8 mt-3 md:mx-10 md:px-10 md:py-3 text-blue font-tenor">
      <p className="uppercase mb-2 text-2xl font-bold">school<span className="block mt-[-6px] text-2xl font-bold">management</span></p>
      <p className="text-base pr-[60%] mb-4">Specialized in the establishment and operating of educational institutions.</p>
      <button className="text-blue text-sm font-semibold bg-yellow px-3 py-2 rounded-xl uppercase hover:scale-105 " onClick={() => (window.location.href = "/projects")}>Explore Our Schools and Programs</button></div></div>
      <div className="hidden md:block col-span-2 absolute top-0 right-0 px-10 z-10 object-contain" data-aos="zoom-in"><img src={I1} alt="" className='h-[29rem] w-[29rem] ' /></div></div>
      

      {/* UPPINGHAM SECTION */}
      <div className='md:m-10 my-10 mx-8' data-aos="fade-up">
      <div className='md:mb-6 mb-4 flex w-full justify-center'><img src={UCLOGO} alt='' className='w-[40%] md:w-[20%]' /></div>
      <p className='md:mx-[8.6rem] mb-4 md:mb-6 font-tenor text-sm md:text-base text-justify text-blue'>{Text2}</p>
      
      <div className="md:px-[8.6rem] mb-4 md:mb-6 flex w-full justify-center overflow-hidden relative" data-aos="fade-up">
      <video className="object-cover w-full [clip-path:inset(6.5px_0_6.5px_0)] md:[clip-path:inset(15px_0_15px_0)]"
      playsInline autoPlay muted={muted} ref={videoRef} onContextMenu={(e) => e.preventDefault()}>
      <source src="/uc-vid.mp4" type="video/mp4" /></video>

      {/* Mute/Unmute Button */}
      <button className="absolute bottom-2 right-2 md:bottom-6 md:right-40 text-white p-2 rounded-md flex items-center justify-center transition-transform duration-200 transform hover:scale-110"
      onClick={() => {if (videoRef.current) {videoRef.current.muted = !videoRef.current.muted; setMuted(videoRef.current.muted);}}}>
      {muted ? <GoMute className='w-[1.15rem] md:w-6 h-auto'/> : <GoUnmute className='w-[1.15rem] md:w-6 h-auto'/>}
      </button></div>

      {/* CAROUSEL SECTION */}
      <div className='md:px-[4.8rem]' data-aos="fade-up"><ImageCarousel images={CarouselImages} /></div></div>


{/* <div data-aos="fade-up" className="p-8 md:m-10 md:px-20 md:py-6 md:rounded-[2.3rem] bg-blue text-white font-tenor">
  <div className="grid md:grid-cols-2 items-center gap-6">
  <div> <p className="text-2xl uppercase mb-4 font-bold">Latest News</p>
  <div className=" md:hidden overflow-hidden rounded-xl mb-4">
  <img src={KingsImage} alt="" className="h-full w-full object-cover transition-transform duration-500 ease-in-out transform hover:scale-105 rounded-xl"/></div>
  <p className="text-base md:text-lg font-bold">{lastNews.title}</p>
  <div className="mt-4"><button className="text-blue bg-yellow text-base py-2 px-12 rounded-md font-semibold transition duration-200 uppercase hover:scale-105" onClick={() => setIsPanelOpen(true)}>Explore</button></div></div>
<div className="hidden md:flex overflow-hidden rounded-xl ml-16">
  <img src={KingsImage} alt="" className="h-full w-full object-cover transition-transform duration-500 ease-in-out transform hover:scale-105 rounded-xl"/></div></div></div> */}


      <NewsPanel date={lastNews.date} title={lastNews.title} img={lastNews.img} text={lastNews.text} isOpen={isPanelOpen} onClose={() => setIsPanelOpen(false)}/>




    </div>
  );};

export default Home;
